export default {
    createBoardHeader: 'Create a Platform',
    createBoard: 'Create a platform',
    whatIsBoards: 'More about ATI.SU platforms',
    boardsDescription: 'ATI.SU participants create platforms and join them to quickly find carrier for loads or loading for trucks.'
};
